import React, { memo, useContext } from 'react';
import styled from 'styled-components';

import { AppContext } from 'src/components/app-context';

type ProductImageProps = {
  fallback?: string | null;
  src?: string | null;
  name?: string | null;
  className?: string;
  height?: number;
  width?: number;
};

type ImageProps = {
  $fallback: boolean;
};

const Image = styled.img<ImageProps>`
  opacity: ${p => (p.$fallback ? 0.2 : 1)};
`;

export const ProductImage = memo(
  ({ fallback, src, name, className, height, width }: ProductImageProps) => {
    const { market = { cdn: 'https://cdn.pji.nu' } } = useContext(AppContext);

    const fallbackImage =
      fallback && !/^https?:\/\//.test(fallback)
        ? market.cdn + fallback
        : fallback;

    const productImage =
      src || fallbackImage || `${market.cdn}/product/standard/280/0.jpg`;

    return (
      <Image
        src={productImage}
        alt={name || ''}
        className={className}
        height={height}
        width={width}
        $fallback={Boolean(!src && fallback)}
      />
    );
  }
);
